import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAppRoles, selectAuthInitialized } from "../redux/userSlice";
import { isAdminOrSriUser } from "../utilities/roleUtils";

const RoleBasedRedirect = () => {
  const navigate = useNavigate();
  const appRoles = useSelector(selectAppRoles);
  const authInitialized = useSelector(selectAuthInitialized);

  useEffect(() => {
    if (authInitialized && isAdminOrSriUser(appRoles)) {
      navigate("/dashboard", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInitialized, appRoles]);

  return null;
};

export default RoleBasedRedirect;